import { Classes } from '@blueprintjs/core';
import { DataAttributeProps } from 'app/types';
import { NoiseClassificationIconMap } from 'app/views/configuration/pages/noise/noise-classifications/noise-classification-icon';
import { ChangeEvent } from 'react';
import {
  SelectableButtonIcon,
  SelectableButtonInner,
  SelectableButtonInput,
  SelectableButtonText,
  SelectableButtonWrapper,
} from './SelectableButton.styles';
import classNames from 'classnames';

type SelectableButtonProps = {
  name: string;
  disabled?: boolean;
  isSelected?: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  isLoading?: boolean;
  icon?: keyof typeof NoiseClassificationIconMap;
  buttonInnerProps?: Omit<React.HTMLAttributes<HTMLSpanElement>, 'className'> & DataAttributeProps;
  className?: string;
};

export const SelectableButton = ({
  name,
  isSelected,
  isLoading = false,
  icon,
  onChange,
  disabled = false,
  buttonInnerProps,
  className,
}: SelectableButtonProps) => {
  return (
    <SelectableButtonWrapper $isLoading={isLoading} data-testid="selectable-button">
      <SelectableButtonInput checked={isSelected} disabled={isLoading || disabled} onChange={onChange} />
      <SelectableButtonInner
        className={classNames(className, {
          [Classes.SKELETON]: isLoading,
        })}
        $isSelected={isSelected}
        {...buttonInnerProps}
      >
        {!!icon && <SelectableButtonIcon icon={icon} />}
        <SelectableButtonText>{name}</SelectableButtonText>
      </SelectableButtonInner>
    </SelectableButtonWrapper>
  );
};
